import { useState } from "react";
import styled from "styled-components";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  width: 100%;
  .info {
    font-size: ${fontSize.xs};
    font-weight: 400;
    color: ${colors.textSecondary};
  }
`;

const Container = styled.div``;

const Line = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${colors.border};
  margin: 20px 0px;
`;

const Section = styled.div`
  font-size: ${fontSize.m};
  span {
    color: ${colors.textSecondary};
  }
`;

const Title = styled.div`
  color: ${colors.black};
  font-weight: 500;
  margin-bottom: 12px;
`;

const FilterList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FilterItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  cursor: pointer;

  &:last-child {
    margin-bottom: 0;
  }
`;

const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;

  &:checked + .custom-radio::after {
    transform: scale(1);
  }
`;

const CustomRadio = styled.span`
  position: relative;
  height: 20px;
  width: 20px;
  background-color: transparent;
  border: 2px solid #ccc;
  border-radius: 50%;
  margin-right: 12px;
  display: inline-block;
  box-sizing: border-box;
  /* &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${colors.black};
    transition: transform 0.2s ease;
  } */

  ${RadioInput}:checked + & {
    border: 4px solid ${colors.black};
  }
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: ${fontSize.s};
  color: ${colors.textSecondary};
  transition: color 0.2s ease;

  &:hover {
    color: ${colors.black};
  }

  ${RadioInput}:checked ~ & {
    color: ${colors.black};
  }
`;

function ProductFilter({ pageNumber, onFilterChange }) {
  const categories = [
    { id: "all", name: "All", count: 10 },
    { id: "blazer set", name: "Blazer Set", count: 10 },
    { id: "coat", name: "Coat", count: 10 },
    { id: "pant & trousers", name: "Pant & Trousers", count: 10 },
    { id: "t-shirt & shirts", name: "T-shirt & Shirts", count: 10 },
    { id: "belt & accessories", name: "Belt & Accessories", count: 10 },
    { id: "sweater & inners", name: "Sweater & Inners", count: 10 },
    { id: "jacket & outer", name: "Jacket & Outer", count: 10 },
    { id: "slipper & shoes", name: "Slipper & Shoes", count: 10 },
    { id: "cap & beanie", name: "Cap & Beanie", count: 10 },
  ];

  const sizes = [
    { id: "XS", name: "XS", count: 25 },
    { id: "S", name: "S", count: 20 },
    { id: "M", name: "M", count: 18 },
    { id: "L", name: "L", count: 12 },
    { id: "XL", name: "XL", count: 12 },
    { id: "XXL", name: "XXL", count: 12 },
    { id: "XXXL", name: "XXXL", count: 12 },
  ];

  const prices = [
    { id: "all", name: "All" },
    { id: "1", name: "High-Low" },
    { id: "-1", name: "Low-High" },
  ];

  // local selected values to keep controls controlled
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedSize, setSelectedSize] = useState("all");
  const [selectedPrice, setSelectedPrice] = useState("all");

  const emitFilters = (cat, size, price) => {
    const payload = {};
    if (cat && cat !== "all") payload.categories = [cat];
    if (size && size !== "all") payload.sizes = [size];
    if (price && price !== "all")
      payload.priceSort =
        price === "1" ? "highToLow" : price === "-1" ? "lowToHigh" : undefined;
    // remove undefined keys
    Object.keys(payload).forEach(
      (k) => payload[k] === undefined && delete payload[k],
    );
    if (onFilterChange) onFilterChange(payload);
  };

  return (
    <Wrapper>
      <span className="info">Showing results: Page {pageNumber}</span>
      <Line />
      <Container>
        <Section>
          <Title>Category</Title>
          <FilterList>
            {categories.map((category) => (
              <FilterItem key={category.id}>
                <RadioInput
                  type="radio"
                  id={`category-${category.id}`}
                  name="category"
                  value={category.id}
                  checked={selectedCategory === category.id}
                  onChange={() => {
                    setSelectedCategory(category.id);
                    emitFilters(category.id, selectedSize, selectedPrice);
                  }}
                />
                <CustomRadio className="custom-radio" />
                <Label htmlFor={`category-${category.id}`}>
                  {category.name}
                </Label>
              </FilterItem>
            ))}
          </FilterList>
        </Section>
        <Line />
        <Section>
          <Title>Size</Title>
          <FilterList>
            {[{ id: "all", name: "All" }, ...sizes].map((s) => (
              <FilterItem key={s.id}>
                <RadioInput
                  type="radio"
                  id={`size-${s.id}`}
                  name="size"
                  value={s.id}
                  checked={selectedSize === s.id}
                  onChange={() => {
                    setSelectedSize(s.id);
                    emitFilters(selectedCategory, s.id, selectedPrice);
                  }}
                />
                <CustomRadio className="custom-radio" />
                <Label htmlFor={`size-${s.id}`}>{s.name}</Label>
              </FilterItem>
            ))}
          </FilterList>
        </Section>
        <Line />
        <Section>
          <Title>Price</Title>
          <FilterList>
            {prices.map((price) => (
              <FilterItem key={price.id}>
                <RadioInput
                  type="radio"
                  id={`price-${price.id}`}
                  name="price"
                  value={price.id}
                  checked={selectedPrice === price.id}
                  onChange={() => {
                    setSelectedPrice(price.id);
                    emitFilters(selectedCategory, selectedSize, price.id);
                  }}
                />
                <CustomRadio className="custom-radio" />
                <Label htmlFor={`price-${price.id}`}>{price.name}</Label>
              </FilterItem>
            ))}
          </FilterList>
        </Section>
        <Line />
      </Container>
    </Wrapper>
  );
}

export default ProductFilter;
